import { filterFalsy } from "./filter-falsy";

export const RxjsUtils = {
    filterFalsy,
};
